export default __webpack_public_path__ + "static/media/bg_2.e8bcd4be.webp";